import { createContext, useContext, useEffect, type ReactNode } from "react";

/**
 * O painel lateral mora na moldura (ao lado do conteúdo), mas quem decide o que vai nele é a página. A página
 * chama `usePainel(conteudo)`; ao sair da página, o painel fecha sozinho.
 */
export const PainelContexto = createContext<(conteudo: ReactNode) => void>(() => {});

export function usePainel(conteudo: ReactNode) {
  const definir = useContext(PainelContexto);
  useEffect(() => {
    definir(conteudo);
  }, [conteudo, definir]);
  useEffect(() => () => definir(null), [definir]);
}
